var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 4.1875C7.45312 4.1875 8.3125 5.04688 8.3125 6.0625C8.3125 7.11719 7.45312 7.9375 6.4375 7.9375C5.38281 7.9375 4.5625 7.11719 4.5625 6.0625C4.5625 5.04688 5.38281 4.1875 6.4375 4.1875ZM17.9609 0.75C19.3672 0.75 20.4609 1.88281 20.4609 3.25V15.75C20.4609 17.1562 19.3281 18.25 17.9609 18.25H2.96094C1.59375 18.25 0.460938 17.1562 0.460938 15.75V3.25C0.460938 1.88281 1.59375 0.75 2.96094 0.75H17.9609ZM18.5859 15.5156V3.25C18.5859 2.9375 18.3125 2.625 17.9609 2.625H2.96094C2.64844 2.625 2.33594 2.9375 2.33594 3.25L2.375 15.75L5.30469 12.0781C5.46094 11.9219 5.65625 11.8047 5.89062 11.8047C6.125 11.8047 6.32031 11.9219 6.47656 12.0781L7.92188 13.875L12.0625 8.25C12.2188 8.05469 12.4141 7.9375 12.6875 7.9375C12.9219 7.9375 13.1172 8.05469 13.2344 8.25L18.5859 15.5156Z",
    fill: "#1D2132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.7846330cd00fb7b0ef823c4812280840.svg";
export { ForwardRef as ReactComponent };